import CircularProgress, {
  CircularProgressProps,
} from '@mui/material/CircularProgress';

import { LoaderStyled } from './LoaderStyled';

interface LoaderProps extends CircularProgressProps {
  isFullScreen?: boolean;
}

export const Loader = ({ isFullScreen = false, ...props }: LoaderProps) => (
  <LoaderStyled data-testid="loader" $isFullScreen={isFullScreen}>
    <CircularProgress
      size={65}
      thickness={2}
      {...props}
      aria-label="Loading..."
    />
  </LoaderStyled>
);
